module.exports = __webpack_public_path__ + "img/icon-pencil-red.ea7c9770.svg";